import React, { useEffect, useState } from "react";
import { Form } from "react-final-form";
import { AddButton } from "../../../shared/components/Buttons";
import ItemFormFields from "../../../booking/components/regular_shuttle/ItemFormFields";
import { serviceName, serviceIconUrl } from "../../../../data/booking/constants/service_types";
import { validate } from "../../../../data/booking/validators/regular_shuttle";
import { useTranslation } from "react-i18next";
import { FormHeading } from "../../../shared/components/Typograhy";
import SlideInAnimation from "../../../shared/components/SlideInAnimation";
import { BackButton, ButtonArea, NextButton } from "../../../shared/components/Buttons";
import { Breadcrumb } from "../form/Breadcrumb";

const ItemForm = ({ serviceType, route, handleSubmit, change, onClickBack }) => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        setShow(true);
    }, []);
    const { t } = useTranslation();

    return (
        <SlideInAnimation show={show} appear={true}>
            <Breadcrumb title={serviceName(serviceType)} />
            <FormHeading title={t("booking.trip_details")} />

            <Form onSubmit={handleSubmit} validate={validate}>
                {({ handleSubmit, pristine, form, submitting, invalid }) => (
                    <form onSubmit={handleSubmit} className="">
                        <ItemFormFields
                            formName="booking_step"
                            route={route}
                            change={change}
                            form={form}
                        />

                        <ButtonArea>
                            <BackButton onClick={onClickBack}>
                                {t("booking.back")}
                            </BackButton>
                            <NextButton
                                classname="ml-auto"
                                disabled={pristine || submitting || invalid}
                                type="submit"
                            >
                                {t("booking.next")}
                            </NextButton>
                        </ButtonArea>
                    </form>
                )}
            </Form>
        </SlideInAnimation>
    );
};
export default ItemForm;
